import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#292a33"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 1a9 9 0 1 1 0-18 9 9 0 0 1 0 18m.5-9.5H17v1h-4.5V17h-1v-4.5H7v-1h4.5V7h1z" />
  </svg>
);
export default SvgAdd;
